import { HttpClient, HttpMethods } from "@planzone/services";

function cancelChatJob(httpClient: HttpClient) {
  return (jobId: string) =>
    httpClient
      .sendHttpRequest({
        endpoint: `/secured/jobs/${jobId}`,
        method: HttpMethods.DELETE,
      })
      .then(() => Promise.resolve());
}

export { cancelChatJob };
